
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AgentConfigPanel from "@/components/ai/AgentConfigPanel";
import AgentHierarchyMap from "@/components/ai/AgentHierarchyMap";
import InsightsTab from "@/components/ai-hub/InsightsTab";

const AIHub = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">AI Hub</h1>
        <p className="text-muted-foreground">
          Manage AI agents, configure capabilities, monitor system performance, and analyze agent interactions across your recruitment platform.
        </p>
      </div>
      
      <Tabs defaultValue="configuration" className="space-y-4">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="configuration">Agent Configuration</TabsTrigger>
          <TabsTrigger value="hierarchy">Agent Hierarchy</TabsTrigger>
          <TabsTrigger value="insights">System Insights</TabsTrigger>
        </TabsList>
        
        <TabsContent value="configuration" className="space-y-4">
          <div>
            <h2 className="text-xl font-semibold mb-2">AI Agent Configuration</h2>
            <p className="text-muted-foreground mb-4">
              Configure your AI agents, assign models, knowledge bases, and customize their behavior.
            </p>
          </div>
          <AgentConfigPanel />
        </TabsContent>
        
        <TabsContent value="hierarchy" className="space-y-4">
          <div>
            <h2 className="text-xl font-semibold mb-2">Agent Hierarchy & Communication</h2>
            <p className="text-muted-foreground mb-4">
              Visualize your agent ecosystem and understand how agents interact and delegate tasks.
            </p>
          </div>
          <AgentHierarchyMap />
        </TabsContent>
        
        <TabsContent value="insights" className="space-y-4">
          <div>
            <h2 className="text-xl font-semibold mb-2">AI Performance Insights</h2>
            <p className="text-muted-foreground mb-4">
              Monitor AI performance, efficiency metrics, and system health across all agents.
            </p>
          </div>
          <InsightsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AIHub;
